import React from 'react'
import styles from './serviceItem.module.css'

function ServiceItem({
    service,
    onClick,
}) {

  const firstImage = service.images && service.images.length > 0 ? service.images[0] : null;

  return (

    <div className={styles.serviceItemWrapper}>
      <div className={styles.serviceItem} onClick={onClick}>
        <div className={styles.content}>
          <div className={styles.header}>
            <h2>{service.name}</h2>
            <p>{service.description}</p>
          </div>
          <div className={styles.details}>
            
          </div>
        </div>

        <div className={styles.imageWrapper}>
          {firstImage && <img src={firstImage.url} alt={service.name} className={styles.image} />}

        </div>

      </div>
    </div>

  )
}

export default ServiceItem
